// extracted by mini-css-extract-plugin
export default {"container":"StatisticsCard_container__VqL0W","description":"StatisticsCard_description__crLte","data":"StatisticsCard_data__DOdj0","icon":"StatisticsCard_icon__aXn7X"};